export default __webpack_public_path__ + "img/ef0704d369aa8bb3bed733054f506c68.png";